export default "__VITE_ASSET__BNZ9xPDk__"